import { BulkActionsComponent } from 'commons/components';
import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import { USER_LOCATION_ASSIGNMENT_I18N_PREFIX } from 'modules/settings/pods/settings-user-location-assignment/settings-user-location-assignment.constants';

interface TenantUsersBulkActionsComponentProps {
    selectedCount: number;
    onClearSelection: VoidFunction;
    onEditLocations: VoidFunction;
}

export const TenantUsersBulkActionsComponent: React.FC<TenantUsersBulkActionsComponentProps> = ({
    selectedCount,
    onClearSelection,
    onEditLocations,
}) => {
    const { t } = useTranslation();

    if (selectedCount === 0) {
        return null;
    }

    return (
        <BulkActionsComponent
            options={[
                <PocTypography key="tenant_users_bulk_selected" element="span" variant="subtitle1">
                    {t(`${USER_LOCATION_ASSIGNMENT_I18N_PREFIX}.bulk-actions.selected`, { amount: selectedCount })}
                </PocTypography>,
                <PocButton
                    key="tenant_users_bulk_clear"
                    variant="tertiary"
                    size="medium"
                    onClick={onClearSelection}
                    data-testid="tenant-users-bulk-clear"
                >
                    {t(`${USER_LOCATION_ASSIGNMENT_I18N_PREFIX}.bulk-actions.clear-all`)}
                </PocButton>,
            ]}
        >
            <BulkActionButtonComponent
                text={t(`${USER_LOCATION_ASSIGNMENT_I18N_PREFIX}.bulk-actions.locations`)}
                iconName="locator"
                onClick={onEditLocations}
                className="tenant-users-bulk-locations"
            />
        </BulkActionsComponent>
    );
};
